
export const rangoAnios = (antes = 0, despues = 0) => {
    //deviuleve un array con una lista de años antes y despues del año actual, si no se envian argumentos solo retorna una lista con el año actual
    let anio = new Date().getFullYear();
    let anios = [];
    for (let i = anio - antes; i < (anio + despues + 1); i++) {
        anios.push(i);
    }
    return anios;
}

export const rangoSemanas = () => {
    let semanas = [];
    for (let i = 1; i < 53; i++) semanas.push(i);
    return semanas;
}

export const obtenerSemanaActual = () => {
    const fechaActual = new Date();
    const diaActual = fechaActual.getDay(); // día de la semana (domingo = 0, lunes = 1, ..., sábado = 6)

    // Día de la semana en JavaScript comienza en domingo (domingo = 0, lunes = 1, ..., sábado = 6)
    // Necesitamos ajustar para que lunes sea el primer día de la semana
    const ajusteDia = (diaActual === 0) ? 6 : diaActual - 1;

    // Obtenemos la fecha del primer día de la semana actual (lunes)
    const primerDiaSemanaActual = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate() - ajusteDia);

    // Calculamos el número de días transcurridos desde el primer día del año hasta la fecha actual
    const milisegundosPorDia = 24 * 60 * 60 * 1000;
    const diasTranscurridos = Math.floor((fechaActual - new Date(fechaActual.getFullYear(), 0, 1)) / milisegundosPorDia) + 1;

    // Calculamos la semana actual contando el número de semanas completas y sumándole 1
    const semanaActual = Math.ceil(diasTranscurridos / 7);

    return semanaActual;
}

export const dateFormatConDiaYHora = (date) => {
    if (!date || typeof date != 'string' || isNaN(Date.parse(date))) return "No disp.";
    let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    let dias_semana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

    let fechaDate = new Date(date);
    if (date.length == 10) date = date + " 00:00:00";
    var dia_semana = dias_semana[fechaDate.getDay()];

    let mont = parseInt(date.substring(5, 7));

    let year = date.substring(0, 4);

    let day = date.substring(8, 10);

    let hour = date.substring(11, 16);

    let meridiano = parseInt(date.substring(11, 13)) > 11 ? "pm" : "am";
    let horaInt = parseInt(date.substring(11, 13));
    horaInt = horaInt > 12 ? horaInt - 12 : horaInt;
    horaInt = horaInt > 9 ? horaInt : `0${horaInt}`;
    let minutos = parseInt(date.substring(14, 16));
    minutos = minutos > 9 ? minutos : `0${minutos}`;

    return `${dia_semana} ${day} ${meses[mont - 1]} ${year} - ${horaInt}:${minutos} ${meridiano}`;
}

export const dateFormatConDiaYHoraShort = (date, msj = "No disp.") => {
    if (!date || typeof date != 'string' || isNaN(Date.parse(date))) return msj;
    let meses = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    let dias_semana = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];

    let fechaDate = new Date(date);
    if (date.length == 10) date = date + " 00:00:00";
    var dia_semana = dias_semana[fechaDate.getDay()];

    let mont = parseInt(date.substring(5, 7));

    let year = date.substring(0, 4);

    let day = date.substring(8, 10);

    let hour = date.substring(11, 16);

    let meridiano = parseInt(date.substring(11, 13)) > 11 ? "pm" : "am";
    let horaInt = parseInt(date.substring(11, 13));
    horaInt = horaInt > 12 ? horaInt - 12 : horaInt;
    horaInt = horaInt > 9 ? horaInt : `0${horaInt}`;
    let minutos = parseInt(date.substring(14, 16));
    minutos = minutos > 9 ? minutos : `0${minutos}`;

    return `${dia_semana} ${day} ${meses[mont - 1]} ${year} - ${horaInt}:${minutos} ${meridiano}`;
}

export const dateFormatConDia = (date, msj = 'No disp.') => {
    if (!date || typeof date !== 'string' || isNaN(Date.parse(date))) return msj;
    let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    let dias_semana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

    let fechaDate = new Date(date);
    let dia_semana = dias_semana[fechaDate.getUTCDay()]; // Usar getUTCDay para evitar problemas de zona horaria
    let day = fechaDate.getUTCDate();
    let month = meses[fechaDate.getUTCMonth()];
    let year = fechaDate.getUTCFullYear();

    return `${dia_semana} ${day} ${month} ${year}`;
}

export const dateFormatConDiaShort = (date) => {
    if (!date || typeof date != 'string' || isNaN(Date.parse(date))) return "No disp.";
    let meses = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
    let dias_semana = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

    let fechaDate = new Date(date);
    var dia_semana = dias_semana[fechaDate.getDay()];

    let mont = parseInt(date.substring(5, 7));

    let year = date.substring(0, 4);

    let day = date.substring(8, 10);

    return `${dia_semana} ${day} ${meses[mont - 1]} ${year - 2000} `;
}

export const dateFormat = (date) => {
    if (!date || typeof date != 'string' || isNaN(Date.parse(date))) return "No disp.";
    let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    let dias_semana = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    let fechaDate = new Date(date);
    var dia_semana = dias_semana[fechaDate.getDay()];
    let mont = parseInt(date.substring(5, 7));

    let year = date.substring(0, 4);

    return `${dia_semana}/${meses[mont - 1]}/${year} `;
}

export const periodoFormat = (date) => {
    if (!date || typeof date != 'string' || isNaN(Date.parse(`${date}-01`))) return "No disp.";
    let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    let mont = parseInt(date.substring(5, 7));

    let year = date.substring(0, 4);

    return `${meses[mont - 1]} - ${year} `;
}

export const ultimoDiaMes = (date) => {
    if (!date || typeof date != 'string' || isNaN(Date.parse(fecha))) return null;

    let fecha = new Date(date);

    // Configurar la fecha al primer día del próximo mes y restar un día
    let ultimoDia = new Date(fecha.getFullYear(), fecha.getMonth() + 2, 0);

    let anio = ultimoDia.getFullYear().toString();
    let mes = ('0' + (ultimoDia.getMonth() + 1)).slice(-2);
    let dia = ('0' + ultimoDia.getDate()).slice(-2);

    // Formatear la fecha en una cadena y devolverla en formato 'YY-mm-dd'
    return anio + '-' + mes + '-' + dia;
}

export const getDate = () => {
    var fecha = new Date();
    var year = fecha.getFullYear();
    var month = ('0' + (fecha.getMonth() + 1)).slice(-2);
    var day = ('0' + fecha.getDate()).slice(-2);
    var hours = ('0' + fecha.getHours()).slice(-2);
    var minutes = ('0' + fecha.getMinutes()).slice(-2);
    var seconds = ('0' + fecha.getSeconds()).slice(-2);

    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

}
